<div class="beni-modal p-5">
    <p><i class="fas fa-check-circle"></i></p>
    <h2 class="my-4">{{message}}</h2>
    <button class="btn save-btn continue-btn" (click)="onContinue()">Continue</button>
  </div>
